const UBICATION_KEY = 'currentUbication';
// Function to set the ubication's data
export function setUbicationData(ubication) {
    sessionStorage.setItem(UBICATION_KEY, JSON.stringify(ubication));
}
// Function to get the ubication's data
export function getUbicationData() {
    const data = sessionStorage.getItem(UBICATION_KEY);
    if (!data) {
        return undefined;
    }
    try {
        return JSON.parse(data);
    }
    catch (error) {
        console.error('Error parsing ubication data:', error);
        return undefined;
    }
}
const UBICATION_ID_KEY = 'currentUbicationID';
// Function to set the ubication's ID data
export function setUbicationIDData(ubication) {
    sessionStorage.setItem(UBICATION_ID_KEY, JSON.stringify(ubication));
}
// Function to get the ubication's ID data
export function getUbicationIDData() {
    const data = sessionStorage.getItem(UBICATION_ID_KEY);
    if (!data) {
        return undefined;
    }
    try {
        return JSON.parse(data);
    }
    catch (error) {
        console.error('Error parsing ubication ID data:', error);
        return undefined;
    }
}
